class ProductMedia extends HTMLElement {
  constructor() {
    super();

    this.gallerySlider = document.querySelector(".js-gallery-slider");
    this.productMediaCarousel = this.parentElement.querySelector(".js-product-media-carousel");
    this.modalTriggers = [...this.querySelectorAll(".js-product-media-trigger"), ...this.productMediaCarousel.querySelectorAll(".js-product-media-trigger")];
    
    if (this.modalTriggers.length && this.gallerySlider) {
      this.modalTriggers.forEach((trigger) => {
        trigger.addEventListener("click", () => {
          const mediaId = trigger.getAttribute("data-media-id");
          const slides = Array.from(this.gallerySlider.querySelectorAll(".js-carousel-slide"));

          if (mediaId) {
            const matchedIndex = slides.findIndex((slide) => slide.getAttribute("data-media-id") === mediaId);
            if (matchedIndex >= 0) {
              this.gallerySlider.scrollToSlide(matchedIndex);
              return;
            }
          }

          // fallback to index
          this.gallerySlider.scrollToSlide(trigger.getAttribute("data-index"));
        });
      });
    }
  }
}

customElements.define("product-media", ProductMedia);

